import React from 'react';

export default ({ text, filter, filterClass = 'filter-text' }) => {
  if (filter && filter.length > 0) {
    const index = text.toLowerCase().indexOf(filter.toLowerCase());
    if (index >= 0) {
      const left = text.substr(0, index);
      const mark = text.substr(index, filter.length);
      const right = text.substr(index + filter.length);
      return (
        <span>{left}<span className={filterClass}>{mark}</span>{right}</span>
      );
    }
  }
  return <span>{text}</span>;
};



// WEBPACK FOOTER //
// ./src/components/FilterText.jsx